import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, Layout, Tooltip } from '@hub-mono/ui';

const FilterCondition = props => {
    const { onChange, isSet, dataCy, disabled } = props;

    const btnsDisabled = isSet === undefined || disabled
    
    return (
        <Layout gap="--Spacing-100">
            <Tooltip
                title={disabled ? `You can't edit filter which was deleted` : 'Is equal to'}
            >
                <IconButton
                    disabled={btnsDisabled}
                    icon="equals"
                    variant={isSet === true ? 'tonal' : 'outlined'}
                    dataCy={`${dataCy || ''}-is-equal-to`}
                    onClick={() => onChange(true)}
                />
            </Tooltip>
            <Tooltip
                title={disabled ? `You can't edit filter which was deleted` : 'Is not equal to'}
            >
                <IconButton
                    disabled={btnsDisabled}
                    icon="notEquals"
                    variant={isSet === false ? 'tonal' : 'outlined'}
                    dataCy={`${dataCy || ''}-is-not-equal-to`}
                    onClick={() => onChange(false)}
                />
            </Tooltip>
        </Layout>
    );
};

FilterCondition.propTypes = {
    onChange: PropTypes.func.isRequired,
    isSet: PropTypes.bool,
};

export default FilterCondition;
